import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeRemainingCountdownComponent } from './time-remaining-countdown.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [TimeRemainingCountdownComponent],
	declarations: [TimeRemainingCountdownComponent]
})

export class TimeRemainingCountdownModule {}
